export type SATPeriodicityType =
  "DAY" |
  "WEEK" |
  "FORTNIGHT" |
  "MONTH" |
  "TWO_MONTHS";

const SATPeriodicityEnum = {
  DAY: 'day',
  WEEK: 'week',
  FORTNIGHT: 'fortnight',
  MONTH: 'month',
  TWO_MONTHS: 'two_months'
};
Object.freeze(SATPeriodicityEnum);

export default SATPeriodicityEnum;
